'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Clock = _ref => {
  let {
    fill,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default["default"].createElement("svg", _extends__default["default"]({
    xmlns: "http://www.w3.org/2000/svg",
    width: "10",
    height: "11",
    viewBox: "0 0 10 11",
    fill: "none"
  }, rest), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.25822 2.98826V5.61737L7.51174 6.9554L7.13615 7.5892L4.50704 5.99296V2.98826H5.25822ZM2.15962 8.34038C2.95775 9.12285 3.90454 9.51408 5 9.51408C6.09546 9.51408 7.03443 9.12285 7.8169 8.34038C8.61502 7.54225 9.01408 6.59546 9.01408 5.5C9.01408 4.40454 8.61502 3.46557 7.8169 2.6831C7.03443 1.88498 6.09546 1.48592 5 1.48592C3.90454 1.48592 2.95775 1.88498 2.15962 2.6831C1.37715 3.46557 0.985916 4.40454 0.985916 5.5C0.985916 6.59546 1.37715 7.54225 2.15962 8.34038ZM1.4554 1.97887C2.44131 0.992958 3.62285 0.5 5 0.5C6.37715 0.5 7.55086 0.992958 8.52113 1.97887C9.50704 2.94914 10 4.12285 10 5.5C10 6.87715 9.50704 8.05869 8.52113 9.0446C7.55086 10.0149 6.37715 10.5 5 10.5C3.62285 10.5 2.44131 10.0149 1.4554 9.0446C0.485133 8.05869 0 6.87715 0 5.5C0 4.12285 0.485133 2.94914 1.4554 1.97887Z",
    fill: fill ?? 'currentColor'
  }));
};
/* eslint-enable react/prop-types */

exports["default"] = Clock;
